export class DealerRole {
  static ROLE_ADMIN = 'admin.dealer.role.admin';
  static ROLE_MODERATOR = 'admin.dealer.role.moderator';
  static ROLE_USER = 'admin.dealer.role.user';
  static ROLE_TABLET = 'admin.dealer.role.tablet';
  public id: number;
  public name: string;
}
